import './PageLoader.css'

interface Props {
  label?: string
}

export function PageLoader({ label = 'загрузка...' }: Props) {
  return (
    <div className="page-loader">
      <div className="page-loader__dot" />
      <span className="page-loader__label">{label}</span>
    </div>
  )
}
